import { render, staticRenderFns } from "./MTextarea.vue?vue&type=template&id=61c69a45&"
import script from "./MTextarea.vue?vue&type=script&lang=ts&"
export * from "./MTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports